import { useQuery } from "@tanstack/react-query";
import { MarqueeMessagesAPI } from "../api";

const fetchData = () => {
  return MarqueeMessagesAPI.get();
};
export const useFetchMarqueeMessages = () => {
  return useQuery({
    queryKey: ["marquee-messages"],
    queryFn: fetchData,
  });
};
